import {inject, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRouteSnapshot, Router, RouterModule} from '@angular/router';
import {FormsModule as NgForms} from '@angular/forms';
import {SessionModule} from '../session/session/session.module';
import {DesignColorsInserterModule} from '@shared/design/design-colors-inserter/design-colors-inserter.module';
import {ScrollingModule} from '@shared/scrolling/scrolling.module';
import {EmailInputModule} from '@management/base/authentication/signup/email-input/email-input.module';
import {SessionFormStore} from './session-form.store';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        loadComponent: () => import('./forms-wrapper/forms-wrapper.component'),
        resolve: {formMetaInformation: (route: ActivatedRouteSnapshot) => inject(SessionFormStore).init(route.params.token)}
      },
      {
        path: 'embed',
        loadComponent: () => import('./forms-embed/forms-embed.component'),
        resolve: {formMetaInformation: (route: ActivatedRouteSnapshot) => inject(SessionFormStore).init(route.params.token)}
      },
      {
        path: 'request',
        pathMatch: 'full',
        loadComponent: () => import('./forms-wrapper/forms-wrapper.component'),
        canActivate: [(route: ActivatedRouteSnapshot, state) => {
          const urlTree = inject(Router).parseUrl(`f/${route.params.token}(modal:fm/${route.params.token}/request)`);
          urlTree.queryParams = route.queryParams;
          return urlTree;
        }],
        // A bit of a hack, because regular redirectTo doesn't allow aux routes & can't handle param-passthrough
      },
      {
        path: 'requested',
        loadComponent: () => import('./form-requested/form-requested.component')
      }
    ]),
    NgForms,
    SessionModule,
    DesignColorsInserterModule,
    ScrollingModule,
    EmailInputModule
  ]
})
export class FormsModule { }
